
import { Button } from "@/components/ui/button";
import { LoadingButton } from "@/components/ui/loading-button";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useTranslations } from "@/hooks/useTranslations";
import { useLanguagePath } from "@/utils/language";

interface AssessmentFormHeaderProps {
  id: string | undefined;
  isSubmitting: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const AssessmentFormHeader = ({
  id,
  isSubmitting,
  onCancel,
  onSubmit,
}: AssessmentFormHeaderProps) => {
  const { t, loading } = useTranslations("assessments");
  const { getPath } = useLanguagePath();
  
  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4 border-b border-slate-100/50 dark:border-gray-700/50">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight gradient-text dark:text-white">
            {id ? t("form.editTitle") : t("form.title")}
          </h2>
          <p className="text-muted-foreground dark:text-gray-300">
            {id ? t("form.editSubtitle") : t("form.subtitle")}
          </p>
          <Breadcrumb className="flex-wrap">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/dashboard")} className="text-flame hover:text-flame/80 dark:text-flame dark:hover:text-flame/80">
                  Dashboard
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/dashboard/assessments")} className="text-flame hover:text-flame/80 dark:text-flame dark:hover:text-flame/80">
                  {t("title")}
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium dark:text-white">{id ? t("form.editTitle") : t("form.title")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <div className="space-x-2">
          <Button 
            variant="outline" 
            onClick={onCancel} 
            disabled={loading}
            className="dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600 dark:border-gray-600"
          >
            {t("form.cancel")}
          </Button>
          <LoadingButton 
            onClick={onSubmit} 
            loading={isSubmitting}
            disabled={loading}
            className="bg-flame hover:bg-flame/90"
          >
            {t("form.save")}
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};
